import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';

const clientPreHydrate = () =>
  i18n
    .use(initReactI18next)
    .use(resourcesToBackend((lng: string) => import(`./locales/${lng}.json`)))
    .init({
      load: 'languageOnly',
      lng: document.documentElement.lang || 'en-EN',
      fallbackLng: 'en-EN',
      ns: 'default',
      fallbackNS: 'default',
      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    });

export default clientPreHydrate;
